import React, { FC, useCallback, useState, useEffect } from 'react';
import cn from 'classnames';
import { Button } from '../../Button';
import { Icon } from '../../Icon';
require("./ProductCardNotification.css");
var styles = {
  "Text": "ProductCardNotification-module-Text_3Yz",
  "Icon": "ProductCardNotification-module-Icon_2po",
  "SubscribeButton": "ProductCardNotification-module-SubscribeButton_1oL",
  "Root": "ProductCardNotification-module-Root_2O0",
  "checked": "ProductCardNotification-module-checked_364"
};
export const ProductCardNotification = ({
  isSubscribe: isSubscribeProp,
  onSubscribe
}) => {
  const [isSubscribe, setIsSubscribe] = useState(isSubscribeProp);
  useEffect(() => {
    setIsSubscribe(isSubscribeProp);
  }, [isSubscribeProp]);
  const handleSubscribe = useCallback(() => {
    setIsSubscribe(isSubscribe => {
      onSubscribe(!isSubscribe);
      return !isSubscribe;
    });
  }, [onSubscribe]);
  return /*#__PURE__*/React.createElement("span", {
    className: cn(styles.Root, {
      [styles.checked]: isSubscribe
    })
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleSubscribe,
    "aria-pressed": isSubscribe,
    "aria-label": `Вы ${isSubscribe ? 'подписаны' : 'не подписаны'} на оповещение о поступлении товара`,
    className: styles.SubscribeButton
  }, isSubscribe && /*#__PURE__*/React.createElement(Icon, {
    name: "checkLarge",
    size: "m",
    className: styles.Icon
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.Text
  }, isSubscribe ? 'Сообщим' : 'Оповестить')));
};